function SvgComponent(props: any) {
  return (
    <svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.617 8.117C15.415 7.465 14.006 7 12.5 7c-4.418 0-8 4-8 5s3.582 5 8 5 8-4 8-5c0-.445-.71-1.484-1.886-2.5M15.5 12a3 3 0 11-6 0 3 3 0 016 0z"
        stroke="#1D1939"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default SvgComponent
